<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 2000 2000"
  >
    <g
      :fill="color"
      :fill-opacity="opacity"
    >
      <path
        d="m509.16,1874.71c-4.58,0-9.21-1.27-13.34-3.93-11.47-7.38-14.78-22.65-7.39-34.12,49.85-77.41,157.65-89.91,169.67-91.06l1187.13-181.94c-4.6-39.79-22.34-76.63-51.08-105.4-33.74-33.77-78.61-52.38-126.34-52.41l-498.81.36h-.02c-13.63,0-24.68-11.04-24.69-24.67,0-13.64,11.03-24.7,24.67-24.71l498.84-.36c60.96.03,118.23,23.78,161.28,66.88,43.06,43.11,66.76,100.4,66.73,161.32,0,12.19-8.9,22.55-20.95,24.39l-1210.02,185.45c-.56.09-1.11.15-1.67.2-.9.08-94.79,8.99-133.22,68.68-4.72,7.33-12.67,11.32-20.78,11.32Z"
      />
      <path
        d="m128.86,1567.79c-4.65,0-9.36-1.31-13.54-4.06-11.39-7.49-14.56-22.8-7.06-34.2,2.72-4.14,8.65-13.45,16.63-25.99,18.6-29.23,46.72-73.41,72.7-112.66,65.9-99.56,141.82-196.76,280.15-196.76h.14l565.25.24c85.31.05,154.67,69.48,154.62,154.77-.05,85.27-69.43,154.6-154.69,154.61h-.08l-366.73-.13c-13.63,0-24.69-11.06-24.68-24.7,0-13.63,11.06-24.68,24.69-24.68h0l366.73.13h.06c28.11,0,54.54-10.94,74.43-30.8,19.9-19.88,30.86-46.32,30.88-74.45.03-58.08-47.19-105.35-105.26-105.38l-565.25-.24h-.11c-113.96,0-178.07,82.6-238.98,174.63-25.73,38.87-53.71,82.83-72.21,111.91-8.17,12.84-14.24,22.38-17.03,26.62-4.75,7.2-12.62,11.12-20.65,11.12Z"
      />
      <path
        d="m1611.4,1095.18h-285.18c-76.09,0-105.93-43.58-118.68-62.2-78.77-115.04-122.15-265.18-122.15-422.75s43.38-307.71,122.15-422.74c12.74-18.61,42.58-62.21,118.68-62.21h285.18c76.09,0,105.94,43.59,118.68,62.21,78.77,115.02,122.14,265.16,122.14,422.74s-43.37,307.71-122.14,422.74h0c-12.75,18.62-42.6,62.21-118.68,62.21Zm-285.18-920.52c-50.06,0-66.84,24.51-77.95,40.72-73.19,106.9-113.51,247.13-113.51,394.84s40.31,287.94,113.51,394.84c11.11,16.22,27.89,40.72,77.95,40.72h285.18c50.05,0,66.84-24.51,77.95-40.72,73.19-106.89,113.5-247.12,113.5-394.84s-40.3-287.95-113.5-394.84c-11.11-16.22-27.88-40.73-77.95-40.73h-285.18Zm383.49,844.36h.1-.1Z"
      />
      <path
        d="m1126.67,798.45H243.61c-53.61,0-97.23-43.62-97.23-97.23v-181.97c0-53.61,43.62-97.23,97.23-97.23h883.05c7.43,0,14.46,3.34,19.14,9.1,4.69,5.76,6.54,13.32,5.03,20.59-10.67,51.61-16.08,104.95-16.08,158.53s5.41,106.92,16.08,158.53c1.5,7.27-.35,14.83-5.03,20.59-4.69,5.76-11.72,9.1-19.14,9.1ZM243.61,471.4c-26.38,0-47.85,21.46-47.85,47.85v181.97c0,26.38,21.46,47.85,47.85,47.85h853.31c-7.66-45.54-11.53-92.1-11.53-138.83s3.88-93.29,11.53-138.83H243.61Z"
      />
      <path
        d="m1640.03,784.65h-157.31c-13.64,0-24.69-11.05-24.69-24.69v-299.46c0-13.64,11.05-24.69,24.69-24.69h157.31c11.39,0,21.29,7.79,24,18.85,12.11,49.83,18.26,102.17,18.26,155.57s-6.14,105.73-18.26,155.57c-2.7,11.07-12.61,18.85-24,18.85Zm-132.62-49.38h112.88c8.37-40.31,12.61-82.29,12.61-125.04s-4.24-84.73-12.61-125.04h-112.88v250.08Z"
      />
      <path
        d="m625.27,634.92h-299.72c-13.64,0-24.69-11.05-24.69-24.69s11.05-24.69,24.69-24.69h299.72c13.64,0,24.69,11.05,24.69,24.69s-11.05,24.69-24.69,24.69Z"
      />
      <path
        d="m883.89,634.92h-106.35c-13.64,0-24.69-11.05-24.69-24.69s11.05-24.69,24.69-24.69h106.35c13.64,0,24.69,11.05,24.69,24.69s-11.05,24.69-24.69,24.69Z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    color: {
      type: String,
      default: '#4d4d4d'
    },
    opacity: {
      type: Number,
      default: 1
    }
  }
}
</script>
